import React, { useEffect, useRef } from "react";

export default function FlyerModal({ flyerUrl, title, onClose }) {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape") onClose();
    }

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    closeButtonRef.current?.focus();

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="flyer-modal-backdrop" onClick={onClose}>
      <div
        className="flyer-modal"
        role="dialog"
        aria-modal="true"
        aria-label={`${title} flyer`}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          ref={closeButtonRef}
          type="button"
          className="flyer-modal-close"
          onClick={onClose}
          aria-label="Close flyer"
        >
          ✕
        </button>

        <img src={flyerUrl} alt={`${title} flyer`} className="flyer-modal-image" />
      </div>
    </div>
  );
}
